<template>
  <!-- Мобильный вариант панели профиля автора: перетаскиваемая шторка, как
       MobileRouteDetailSheet.vue (во всю ширину, вплотную к нижней панели).
       Строки действий нет - внизу остаются вкладки. -->
  <div ref="rootEl" class="md:hidden absolute inset-x-0 bottom-0 z-40 pointer-events-none" data-profile-sheet>
    <div
      class="absolute inset-x-0 bottom-0 bg-card rounded-t-xl border-t border-x border-border shadow-ink-lg overflow-hidden pointer-events-auto flex flex-col"
      :class="!isDragging && 'transition-[height] duration-200 ease-out'"
      :style="{ height: sheetHeight + 'px' }"
      @pointerdown="onSheetPointerDown"
    >
      <div class="shrink-0 py-1.5 flex flex-col items-center select-none" style="touch-action: none" data-sheet-drag-handle>
        <div class="w-10 h-1 rounded-full bg-[hsl(var(--muted-foreground)/0.3)]" />
      </div>

      <UserProfilePanel
        ref="panelRef"
        class="flex-1 min-h-0"
        :username="username"
        compact
        @back="$emit('back')"
        @close="$emit('close')"
        @open-route="$emit('open-route', $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { DRAG_HANDLE_HEIGHT, useDragSheet } from "../composables/useDragSheet";
import UserProfilePanel from "./UserProfilePanel.vue";

// covered - поверх открыта карточка точки (шторка скрыта v-show в App.vue).
const props = defineProps<{ username: string; covered?: boolean }>();
defineEmits<{
  (e: "back"): void;
  (e: "close"): void;
  (e: "open-route", id: number): void;
}>();

const rootEl = ref<HTMLElement | null>(null);
const panelRef = ref<InstanceType<typeof UserProfilePanel> | null>(null);
const mapHeight = () => rootEl.value?.offsetParent?.clientHeight ?? 0;
const headerHeight = computed(() => panelRef.value?.headerHeight ?? 0);

// Высота открытия - вся высота карты (список маршрутов автора; тянуть вниз
// можно). Пока шапка не измерена - 0 (useDragSheet берёт 30% окна).
// useDragSheet прибавляет к compactHeight высоту ручки - вычитаем её, чтобы
// открытая шторка равнялась ровно высоте карты.
const compactHeight = computed(() =>
  headerHeight.value > 0 ? Math.max(0, Math.round(mapHeight() || window.innerHeight) - DRAG_HANDLE_HEIGHT) : 0
);

const { sheetHeight, isDragging, onSheetPointerDown, collapse } = useDragSheet({
  bottomGap: 0,
  getMaxHeight: mapHeight,
  compactHeight,
  headerHeight,
  resetKey: () => props.username,
  active: () => !props.covered,
});

// collapse - App.vue на map-interact (тап по пустой карте / её перетаскивание).
defineExpose({ collapse });
</script>
